import ApiClientError from "./ApiClientError";

class ConnectionError extends ApiClientError {
  constructor(request: $TSFixMe, response: $TSFixMe, cause: $TSFixMe) {
    super(
      "ConnectionError",
      undefined,
      "Internet connection interrupted or server closed connection.",
      request,
      response,
      cause,
    );
  }
}

export default ConnectionError;
